<div class="headerWrapper">
  @if (application$ | async; as application) {
    <div class="navbar fixed-top container-fluid pl-0" #fixedHeader>
      <dnv-mood-canvas class="dnv-mood-canvas"></dnv-mood-canvas>
      <div class="row w-100 mx-0 d-flex justify-content-between">
        <div class="col-xl-4 col-lg-3 pl-0 col-3">
          <h1 class="navbar-brand" title="GeoTools">
            Geotools @if (isNarwhal()) {
            <i class="fa-solid fa-narwhal ml-2" title="Hi {{userName()}}!"></i>
          }
        </h1>
      </div>
      <!-- Removed for MVP Build -->
      <div class="col-xl-4 col-lg-5 col-4 save-map-view d-flex justify-content-center">
        @if (applicationState.toolboxStatus !== ToolboxStatus.WMRP) {
          <div (click)="openMapViewDialog()" title="Open Map View"
            >
            <dnv-map-view #mapViewComponent [mapViewState]="mapViewState$ | async" (mapViewOutput)="mapViewUpdate($event)"
              (mapViewSelect)="mapViewUpdate($event)">
            </dnv-map-view>
          </div>
        }
      </div>
      <div class="col-xl-4 col-lg-4 col-5 d-flex justify-content-end search">
        <div class="showSpin">
          @if ((application$ | async).searchSpinner) {
            <div>
              <i class="fas fa-2x fa-spinner fa-spin"></i>
            </div>
          }
        </div>
        <div class="search-field mr-2">
          <div class="form-group" [formGroup]="searchForm">
            <input type="text" class="form-control" id="addressSearch" formControlName="addressSearch"
              placeholder="Search for anything" [resultTemplate]="rt" [inputFormatter]="formatter" [container]="body"
              (blur)="onBlur()" (keyup)="onClearSearch($event)" [ngbTypeahead]="search"
              (selectItem)="onSelectItem($event)" (keydown.enter)="zoomToSearch()">
            </div>
            @if (this.searchForm.get('addressSearch').value) {
              <button type="button" class="clear-search"
                (click)="onClearClicked()">
                <i class="far fa-times-circle clear-search-icon"></i>
              </button>
            }
          </div>
          <div class="navbar-user" ngbDropdown display="dynamic">
            <button type="button" class="btn btn-link" id="dropdownBasic1" ngbDropdownToggle>{{ userIcon }}</button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="logout()">Sign out</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<dnv-lightrope lightropeStart="12-10" lightropeEnd="12-26"></dnv-lightrope>
@if (application$ | async; as application) {
  <div class="container-fluid p-0"
    [class.props]="application.toolboxStatus === ToolboxStatus.PropertyInfo || application.toolboxStatus === ToolboxStatus.MailMerge || application.toolboxStatus === ToolboxStatus.ServiceConnections"
    [class.streetview]="application.streetView">
    <div class="map" [class.eng-draw]="drawBtn === 'eng-polygon' && !isDesktop"
      [class.panelOpen]="application.status !== ApplicationStatus.Idle"
      [class.secondPanelOpen]="(layerState$ | async).showFilterPanel || (legendState$ | async).editFeatureLayerSymbology !== null">
      <dnv-map-basemap [mapState]="mapState$ | async" [baseMapState]="(baseMapState$ | async).basemap"
        (onSetBaseMap)="onSelectBasemap($event)" (onToggleBasemaps)="toggleBasemaps()" class="basemap" [showSlider]="true"
        (onOpacityChange)="onOrthoOpacityChange($event)">
      </dnv-map-basemap>
      <dnv-map (mapClick)="onMapClick($event)" (shapeCreated)="onShapeCreated($event)"
        (mapMoveChange)="onMoveChange($event)" (mapZoomChange)="onZoomChange($event)" (mapUpdate)="onMapUpdate($event)"
        [mapState]="mapState$ | async" [layerState]="layerState$ | async" [textStyle]="textStyle"
        (editText)="editText($event)" (engSearch)="searchEngDrawings($event)" (shapeClick)="onShapeClick($event)"
        (moveText)="moveText()" (customBtnEventClick)="onCustomBtnClick($event)"
        (setMeasurements)="onSetMeasurements($event)" (newFeatureAdded)="onNewFeatureAdded($event)"
        (featureLatLng)="onLatLngEmit($event)" (checkMapViewDirty)="onCheckMapViewDirty()"
        (editedFeature)="onEditedFeature($event)" (coordinatesEmit)="onCoordinatesEmit($event)" #dnvMap>
      </dnv-map>
      @if ((application$ | async).measurements && (application$ | async).fromMeasureTool) {
        <div>
          <dnv-measurements class="measure-info" [measurements]="(application$ | async).measurements"
          (clearMeasurements)="onSetMeasurements({leafletId: 0, measurements: null})"></dnv-measurements>
        </div>
      }
      <div class="print-only titleContainer text-center" leaflet-browser-print-content>
        <h1 class="mapTitle">
          {{mapTitle}}
        </h1>
        <h3 class="mapSubTitle">
          {{mapSubTitle}}
        </h3>
      </div>
      <div class="print-only north-arrow {{mapLegendPosition}}" [class.with-title]="isMapTitle()"
        leaflet-browser-print-content>
        <span class="letter d-block">N</span><i class="fas fa-location-arrow fa-lg"></i>
      </div>
      @if ((legendState?.legendLayers?.length > 0 || baseMapState?.basemapLegends?.length > 0) && mapLegendEnabled) {
        <div id="printableLegend" class="print-only {{printMode}} {{mapLegendPosition}}" [class.title]="isMapTitle()"
          leaflet-browser-print-content
          >
          <dnv-legend [legendLayers]="(legendState$ | async).legendLayers"
            [featureLayers]="(mapState$ | async).featureLayers"
          [editFeatureLayerSymbology]="(legendState$ | async).editFeatureLayerSymbology"></dnv-legend>
          <dnv-legend [legendLayers]="(baseMapState$ | async).basemapLegends"></dnv-legend>
        </div>
      }
    </div>
    <div id="interface-container" class="row m-0 interface-container">
      <div class="left-nav-wrapper d-flex">
        <div class="sidebar text-center">
          <button id="btnDrawerLayers" type="button" class="btn btn-link"
            [class.active-btn]="application.status === ApplicationStatus.Layer" (click)="toggleLayer(application.status)"
            title="Layers">
            <i class="far fa-layer-group"></i>
          </button>
          <button id="btnDrawerTable" type="button" class="btn btn-link"
            [class.active-btn]="application.status === ApplicationStatus.Table" (click)="toggleTable(application.status)"
            title="Table">
            <i class="far fa-table"></i>
          </button>
          <button id="btnDrawerLegend" type="button" class="btn btn-link" title="Legend"
            [class.active-btn]="application.status === ApplicationStatus.Legend"
            (click)="toggleLegend(application.status)">
            <i class="far fa-list-alt"></i>
          </button>
          <div class="light-grey-border"></div>
          <!-- <button type="button" class="btn btn-link" [class.active-btn]="application.status === ApplicationStatus.Measure"
          title="Measure">
          <i class="fal fa-ruler-combined"></i>
        </button> -->
        <button id="btnDrawerDraw" type="button" class="btn btn-link d-none d-sm-block"
          [class.active-btn]="application.status === ApplicationStatus.Draw" title="Draw"
          (click)="toggleDraw(application.status)">
          <i class="far fa-pencil-ruler"></i>
        </button>
        <button id="btnDrawerExport" type="button" class="btn btn-link d-none d-sm-block"
          [class.active-btn]="application.status === ApplicationStatus.Export"
          (click)="toggleExport(application.status)" title="Print">
          <i class="far fa-print"></i>
        </button>
        <div class="light-grey-border"></div>
        <button id="btnDrawerToolbox" type="button" class="btn btn-link"
          [class.active-btn]="application.status === ApplicationStatus.Toolbox"
          [class.on]="(applicationState.toolboxStatus !== ToolboxStatus.Idle )" [title]="getToolboxTitleText()"
          (click)="toggleToolbox(application.status)">
          <i class="far fa-toolbox"></i>
        </button>
      </div>
      <div id="layerDiv" class="panel" [class.fade]="application.status !== ApplicationStatus.Layer">
        <div class="container py-2 px-0">
          <div class="pt-1">
            <div class="d-block title">
              <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close"
                (click)="toggleLayer(application.status)">
                <div class="chevron-wrapper">
                  <i class="fas fa-chevron-left fa-sm"></i>
                </div>
                <div class="d-inline-block mt-2 title-text">Layer Control</div>
              </button>
            </div>
          </div>
          <dnv-layer [layerState]="layerState$ | async" [mapState]="mapState$ | async"
            (onSetAvailableLayer)="setAvailableLayer($event)" (onSetActiveLayer)="setActiveLayer($event)"
            (onLayersOrdered)="onLayersOrdered($event)" (onToggleShowFilterPanel)="onToggleShowFilterPanel($event)"
            [showFilterButton]="true" [showHideLayerButton]="true" (onToggleExpand)="onToggleExpand($event)"
            (onHideLayer)="onHideLayer($event)" (onHideFeatureLayer)="onHideFeatureLayer($event)"
            (onClearActiveLayer)="onClearActiveLayer($event)" (onSetOpacity)="onSetOpacity($event)"
            (filterAOI)="onFilterAOI($event)">
          </dnv-layer>
          @if ((layerState$ | async).layers.length === 0) {
            <div class="d-flex justify-content-center">
              <i class="fas fa-3x fa-spinner fa-spin"></i>
            </div>
          }
        </div>
      </div>
      <div id="layerFilterDiv" class="secondary-panel"
        [class.fade]="!(application.status === ApplicationStatus.Layer && (layerState$ | async).showFilterPanel)"
        >
        <div class="pt-1 title-wrapper">
          <div class="d-block title" (click)="hideFilterPanel()">
            <button class="btn btn-link float-left" title="Close Layer Filter">
              <i class="fas fa-chevron-left fa-sm"></i>
            </button>
            <div class="d-inline-block filters-title title-text" title="Layer Filter">Layer Filter</div>
          </div>
        </div>
        <dnv-layer-filter [layerState]="layerState$ | async" [headerHeight]=" headerHeight" [link]="application.link"
          (updateFilter)="onUpdateFilter($event)" (zoomToFeatures)="onZoomToFeatures($event)">
        </dnv-layer-filter>
      </div>
      <div id="legendDiv" class="panel" 
        [class.fade]="!(application.status === ApplicationStatus.Legend)">
        <div class="container py-2 px-0">
          <div class="pt-1">
            <div class="d-block title">
              <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close"
                (click)="toggleLegend(application.status)">
                <div class="chevron-wrapper">
                  <i class="fas fa-chevron-left fa-sm"></i>
                </div>
                <div class="d-inline-block mt-2 title-text">Legend</div>
              </button>
            </div>
          </div>
          <dnv-legend [clickEmit]="true" [legendLayers]="(legendState$ | async).legendLayers"
            [featureLayers]="(mapState$ | async).featureLayers"
            [editPermissions]="(application$ | async).editPermission"
            [isEditTool]="(mapState$ | async).editFeaturesPermission"
            (showSymbolizeComponentEmitter)="onShowSymbolizeComponentEmitter($event)"
            (infoEmitter)="onMetadataClick($event)">
          </dnv-legend>
          <dnv-legend [legendLayers]="(baseMapState$ | async).basemapLegends"
            (showSymbolizeComponentEmitter)="onShowSymbolizeComponentEmitter($event)"
            (infoEmitter)="onMetadataClick($event)">
          </dnv-legend>
          @if ((legendState$ | async).legendLayers && (legendState$ | async).legendLayers.length === 0 && (baseMapState$ | async).basemapLegends && (baseMapState$ | async).basemapLegends.length === 0) {
            <div
              class="pt-2 pl-2">
              There is no legend to display
            </div>
          }
        </div>
      </div>
      @if (legendState$ | async; as legendState) {
        <div class="secondary-panel symbolize" 
          [class.fade]="!(application.status === ApplicationStatus.Legend && (legendState$ | async).editFeatureLayerSymbology !== null)"
          >
          <div class="pt-1 title-wrapper">
            <div class="d-block title" (click)="onDnvLegendSymbolizeCancel()">
              <button class="btn btn-link float-left" title="Close Symbolize">
                <i class="fas fa-chevron-left fa-sm"></i>
              </button>
              <div class="d-inline-block filters-title title-text" title="Symbolize">Symbolize</div>
            </div>
          </div>
          <dnv-legend-symbolize [editFeatureLayerSymbology]="legendState.editFeatureLayerSymbology"
            [symbologies]="legendState.symbologies" [featureLayers]="(mapState$ | async).featureLayers"
            (applyEmitter)="onDnvLegendSymbolizeApply($event)" (cancelEmitter)="onDnvLegendSymbolizeCancel()">
          </dnv-legend-symbolize>
        </div>
      }
      <div id="metaDataDiv" class="secondary-panel" 
        [class.fade]="!(application.status === ApplicationStatus.Legend && (legendState$ | async).showMetadata)">
        <div class="pt-1 title-wrapper">
          <div class="d-block title" (click)="hideMetaData()">
            <button class="btn btn-link float-left" title="Close Metadata">
              <i class="fas fa-chevron-left fa-sm"></i>
            </button>
            <div class="d-inline-block filters-title title-text" title="Metadata">Metadata</div>
          </div>
        </div>
        <app-dnv-metadata [legendState]="legendState$ | async"></app-dnv-metadata>
      </div>
      <div id="exportDiv" class="panel" [class.fade]="application.status !== ApplicationStatus.Export"
        >
        <div class="container py-2 px-0">
          <div class="pt-1">
            <div class="d-block title" (click)="toggleExport(application.status)">
              <button class="btn btn-link float-left" title="Close Export">
                <i class="fas fa-chevron-left fa-sm"></i>
              </button>
              <div class="d-inline-block mt-2 title-text" title="Print Map">Print Map</div>
            </div>
          </div>
        <dnv-export [mapState]="mapState$ | async" [windowWidth]="(application$ | async).windowInnerWidth"
          [windowHeight]="panelHeight" (printEmitter)="printMap($event)" (mapTitleEmitter)="onChangeMapTitle($event)"
          (mapSubtitleEmitter)="onChangeMapSubtitle($event)"
          (mapLegendPositionEmitter)="onChangeMapLegendPosition($event)"
          (mapLegendEnabledEmitter)="onChangeMapLegendEnabled($event)"
          (mapBorderEnabledEmitter)="onChangeMapBorderEnabled($event)">
        </dnv-export>
      <!-- </div> -->
    </div>
  </div>
  <div id="DrawDiv" class="panel" 
    [class.fade]="!(application.status === ApplicationStatus.Draw)">
    <div class="container py-2 px-0">
      <div class="pt-1">
        <div class="d-block title">
          <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close"
            (click)="toggleDraw(application.status)">
            <div class="chevron-wrapper">
              <i class="fas fa-chevron-left fa-sm"></i>
            </div>
            <div class="d-inline-block mt-2 title-text">Draw</div>
          </button>
        </div>
      </div>
      <div class="form-group px-3">
        <p class="pl-1 pt-2">
          Click on desired icon to start drawing, click again to stop.
        </p>
        <p class="fst-italic fw-bold">
          Features drawn here are not exportable to the GIS.
        </p>
        <div class="mr-2 pl-1 col-2">
          Draw:
        </div>
        <div class="draw-buttons mt-2 d-flex">
          <button type="button" class="btn btn-outline-secondary btn-labelmarker"
            [class.on]="drawBtn === 'labelmarker'" (click)="toggleAddLabel();" title="Add Label"
            id="btn-labelmarker">
            <i class="far fa-text" data-fa-transform="grow-4 up-2 left-1"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary btn-drawLine" [class.on]="drawBtn === 'line'"
            (click)="toggleDrawline();" title="Draw a line" id="btn-drawLine">
            <i class="far fa-grip-lines-vertical" data-fa-transform="rotate-35 grow-4 up-2 left-1"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary btn-polygon" [class.on]="drawBtn === 'polygon'"
            (click)="togglePolygon();" title="Draw a polygon" id="btn-polygon">
            <i class="far fa-draw-polygon" data-fa-transform="grow-4 up-2 left-1"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary btn-marker" [class.on]="drawBtn === 'marker'"
            (click)="toggleMarker();" title="Place a marker" id="btn-marker">
            <i class="fas fa-map-marker-alt" data-fa-transform="grow-4 up-2 left-1"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary btn-circle" [class.on]="drawBtn === 'circle'"
            (click)="toggleCircle();" title="Draw a circle" id="btn-circle">
            <i class="fas fa-draw-circle" data-fa-transform="grow-4 up-2 left-1"></i>
          </button>
        </div>
      </div>
      <div class="form-group pl-3">
        <div class="mr-2 pl-1 col-2">
          Edit:
        </div>
        <div class="draw-buttons mt-2 d-flex ">
          <button type="button" class="btn btn-outline-secondary btn-edit"
            [class.on]="drawBtn === 'edit' && mapState.editShapes === true" (click)="toggleEdit();"
            title="Select Shape" id="btn-edit">
            <i class="fas fa-mouse-pointer" data-fa-transform="grow-4 up-2 left-1"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary" [class.on]="drawBtn === 'deleteOne'"
            (click)="deleteShape();" title="Delete selected drawing" id="btn-deleteOne"
            [disabled]="!isShapeSelected()">
            <i class="fas fa-minus-circle" data-fa-transform="grow-4 up-3 left-2"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary btn-deleteAll" [class.on]="drawBtn === 'deleteAll'"
            (click)="deleteAllShapes();" title="Clear all Drawings" id="btn-deleteAll">
            <i class="fas fa-trash" data-fa-transform="grow-4 up-2 left-1"></i>
          </button>
        </div>
      </div>
      <!-- shapes color / style / size-->
      @if (drawBtn === 'addText' || editingShape === 'addText') {
        <p class="pl-3">
          - Click on text to enable move, drag anchor to move<br>
          - Double click to edit text, colour, text size
        </p>
      }
      <!--<hr class="mx-3" *ngIf="(drawBtn === 'edit' && editingShape !== 'AddText')" />-->
      @if ((drawBtn === 'edit' && editingShape && editingShape !== 'AddText') && isShapeSelected()) {
        <div class="form-group pl-3"
          >
          <div class="draw-buttons mt-2">
            <div class="row mx-0"><label class="pr-0 col-form-label">Layer order:</label></div>
            <div class="row mx-0">
              <button (click)="bringToFront()" title="bring to front" class="btn btn-outline-secondary btn-front">
                <i class="fad fa-bring-forward"></i>
              </button>
              <button (click)="bringToBack()" title="send to back" class="btn btn-outline-secondary btn-back">
                <i class="fas fa-send-backward"></i>
              </button>
            </div>
          </div>
        </div>
      }
      <!--<hr class="mx-3"
      *ngIf="(drawBtn !== 'cancel' && drawBtn !== 'edit') || (drawBtn === 'edit' && editingShape !== '')" />-->
      <div class="px-3">
      @if ((drawBtn !== 'cancel' && drawBtn !== 'edit') || (drawBtn === 'edit' && editingShape !== '' && isShapeSelected())) {
        <div class="form-group d-flex mx-0 py-2"
          >
          <label class="col-3 pr-0 col-form-label">Color: </label>
          <div class="col-4 pr-0">
            <input type="text" [value]="(mapState$ | async).shapeOutline" class="color-input form-control"
              [ngbPopover]="popContent" placement="bottom" (blur)="setColor($event)" #pop="ngbPopover"
              popoverClass="colours" />
            </div>
            <button type="button" (click)="openSwatches(pop)" class="btn btn-link p-0" id="btn-colorSwatch">
              <div class="selected-swatch" [style.backgroundColor]="(mapState$ | async).shapeOutline">
              </div>
            </button>
          </div>
        }
        <ng-template #popContent>
          <div class="d-flex flex-row color-swatches">
            @for (col of colorSwatches; track col) {
              <div>
                @for (color of col; track color) {
                  <div>
                    <color-swatches-color [color]="color" [active]="(mapState$ | async).shapeOutline === color"
                      (onSwatchHover)="onSwatchHover($event)" (onClick)="changeComplete($event)">
                    </color-swatches-color>
                  </div>
                }
              </div>
            }
          </div>
        </ng-template>
        @if ((drawBtn === 'addText' || (editingShape === 'addText' && isShapeSelected()) || drawBtn === 'labelmarker' || (editingShape === 'labelmarker' && isShapeSelected()))) {
          <div
            >
            <div class="form-group d-flex">
              <label class="col-3 pr-0 col-form-label">
                Size:
              </label>
              <div class="col-4 pr-0">
                <select class="form-select" (change)="setFontSize($event)">
                  @for (x of getSize(8, 64); track x) {
                    <option [value]="x" [selected]="selectedFontSize === x">
                      {{x}}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="form-group d-flex">
              <label class="col-3 pr-0 col-form-label">Font: </label>
              <div class="col-6 pr-0">
                <select class="form-select" (change)="setFontFace($event)">
                  @for (f of fontFace; track f) {
                    <option [value]="f" [selected]="textStyle.fontFace === f">
                      {{f}}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="form-group d-flex">
              <label class="col-3 pr-0 col-form-label">Angle: </label>
              <div class="col-8 pr-0">
                <ngx-slider [formControl]="sliderControl" [options]="sliderOptions" (userChange)="getSliderValue();"
                  [value]="value">
                </ngx-slider>
              </div>
            </div>
          </div>
        }
        @if (drawBtn === 'labelmarker' || (editingShape === 'labelmarker' && isShapeSelected())) {
          <div>
            <div class="form-group d-flex">
              <label class="col-3 pr-0 col-form-label">Label: </label>
              <div class="col-8 pr-0">
                <textarea id="labeltext" placeholder="Enter Label Text Here" (input)="labelTextChanged($event)"
                [ngModel]="(mapState$ | async).labelMarkerText" style="width: 100%;"></textarea>
              </div>
            </div>
          </div>
        }
        @if (drawBtn !== 'cancel' && (drawBtn === 'circle'  || (editingShape === 'circle' && isShapeSelected()))) {
          <div
            class="form-group circle row mx-0">
            <label class="col-3 pr-0 col-form-label px-0">Radius: </label>
            <div class="col-4 pr-0 ps-0">
              <input type="text" id="radius" class="form-control" [formControl]="circleRadius"
                [value]="(mapState$ | async).circleRadius">
              </div>
            </div>
          }
          @if (drawBtn === 'line'  || (editingShape === 'LineString' && isShapeSelected())) {
            <div
              class="form-group lines d-flex">
              <label class="col-3 pr-0 col-form-label">Style: </label>
              <div class="col-8">
                <ng-select [ngModel]="(mapState$ | async).lineStyle" (change)="setLineStyle($event)">
                  <ng-option [value]="'line'">
                    <svg viewBox="0 0 100 6" xmlns="http://www.w3.org/2000/svg">
                      <line x1="0" y1="1" x2="100" y2="1" stroke="black"></line>
                    </svg>
                  </ng-option>
                  <ng-option [value]="'dash1'">
                    <svg viewBox="0 0 100 6" xmlns="http://www.w3.org/2000/svg">
                      <line x1="0" y1="1" x2="100" y2="1" stroke="black" style="stroke-dasharray: 10, 5;"></line>
                    </svg>
                  </ng-option>
                  <ng-option [value]="'dash2'">
                    <svg viewBox="0 0 100 6" xmlns="http://www.w3.org/2000/svg">
                      <line x1="0" y1="1" x2="100" y2="1" stroke="black" style="stroke-dasharray: 5, 10;"></line>
                    </svg>
                  </ng-option>
                  <ng-option [value]="'dash3'">
                    <svg viewBox="0 0 100 6" xmlns="http://www.w3.org/2000/svg">
                      <line x1="0" y1="1" x2="100" y2="1" stroke="black" style="stroke-dasharray: 10, 3, 2, 3;"></line>
                    </svg>
                  </ng-option>
                  <ng-option [value]="'dash4'">
                    <svg viewBox="0 0 100 6" xmlns="http://www.w3.org/2000/svg">
                      <line x1="0" y1="1" x2="100" y2="1" stroke="black" style="stroke-dasharray: 10, 3, 3, 3, 3, 3;">
                      </line>
                    </svg>
                  </ng-option>
                  <ng-option [value]="'arrow-line'">
                    <svg viewBox="0 0 100 6" xmlns="http://www.w3.org/2000/svg" style="width: 92%;">
                      <line x1="0" y1="1" x2="100" y2="1" stroke="black"></line>
                    </svg>
                    <i class="far fa-chevron-right"></i>
                  </ng-option>
                  <ng-option [value]="'dash1-arrow'">
                    <svg viewBox="0 0 100 6" xmlns="http://www.w3.org/2000/svg" style="width: 92%;">
                      <line x1="0" y1="1" x2="100" y2="1" stroke="black" style="stroke-dasharray: 10, 5;"></line>
                    </svg>
                    <i class="far fa-chevron-right"></i>
                  </ng-option>
                  <ng-option [value]="'dash2-arrow'">
                    <svg viewBox="0 0 100 6" xmlns="http://www.w3.org/2000/svg" style="width: 92%;">
                      <line x1="0" y1="1" x2="100" y2="1" stroke="black" style="stroke-dasharray: 5,10;"></line>
                    </svg>
                    <i class="far fa-chevron-right"></i>
                  </ng-option>
                  <ng-option [value]="'dash3-arrow'">
                    <svg viewBox="0 0 100 6" xmlns="http://www.w3.org/2000/svg" style="width: 92%;">
                      <line x1="0" y1="1" x2="100" y2="1" stroke="black" style="stroke-dasharray: 10, 3, 2, 3;"></line>
                    </svg>
                    <i class="far fa-chevron-right"></i>
                  </ng-option>
                  <ng-option [value]="'dash4-arrow'">
                    <svg viewBox="0 0 100 6" xmlns="http://www.w3.org/2000/svg" style="width: 92%;">
                      <line x1="0" y1="1" x2="100" y2="1" stroke="black" style="stroke-dasharray: 10, 3, 3, 3, 3, 3;">
                      </line>
                    </svg>
                    <i class="far fa-chevron-right"></i>
                  </ng-option>
                </ng-select>
              </div>
            </div>
          }
          @if (drawBtn === 'polygon' || drawBtn === 'circle' || ((editingShape === 'Polygon' || editingShape === 'circle') && isShapeSelected())) {
            <div
              class="row mx-0 form-group patterns">
              <label class="col-3 pr-0 col-form-label px-0">Style: </label>
              <div class="col-8 ps-0">
                <ng-select (change)="changePattern($event)" [ngModel]="(mapState$ | async).fillPattern">
                  <ng-option [value]="'solid'">
                    <svg version="1.1" baseProfile="full" width="90" height="25" xmlns="http://www.w3.org/2000/svg">
                      <rect width="100%" height="100%" rx="5"
                        style="fill:rgb(0,0,0); fill-opacity: 0.2;stroke-width:2;stroke:rgb(0,0,0)" />
                      </svg>
                    </ng-option>
                    <ng-option [value]="'horizontal'">
                      <svg version="1.1" baseProfile="full" width="90" height="25" xmlns="http://www.w3.org/2000/svg">
                        <rect width="100%" height="100%" rx="5" fill="url(#hstripes)" stroke="#000" storke-width="2" />
                      </svg>
                    </ng-option>
                    <ng-option [value]="'vertical'">
                      <svg version="1.1" baseProfile="full" width="90" height="25" xmlns="http://www.w3.org/2000/svg">
                        <rect width="100%" height="100%" rx="5" fill="url(#vstripes)" stroke="#000" storke-width="2" />
                      </svg>
                    </ng-option>
                    <ng-option [value]="'grid'">
                      <svg version="1.1" baseProfile="full" width="90" height="25" xmlns="http://www.w3.org/2000/svg">
                        <rect width="100%" height="100%" rx="5" fill="url(#grid)" stroke="#000" storke-width="2" />
                      </svg>
                    </ng-option>
                    <ng-option [value]="'crosshatch'">
                      <svg version="1.1" baseProfile="full" width="90" height="25" xmlns="http://www.w3.org/2000/svg">
                        <rect width="100%" height="100%" rx="5" fill="url(#crosshatch)" stroke="#000" storke-width="2" />
                      </svg>
                    </ng-option>
                    <ng-option [value]="'empty'">
                      <svg version="1.1" baseProfile="full" width="90" height="25" xmlns="http://www.w3.org/2000/svg">
                        <rect width="100%" height="100%" rx="5" stroke="#000" storke-width="2" fill-opacity="0" />
                      </svg>
                    </ng-option>
                  </ng-select>
                </div>
              </div>
            }
            @if (showThickness()) {
              <div class="form-group lines d-flex row mx-0">
                <label class="col-3 px-0 col-form-label">Thickness: </label>
                <div class="col-4 ps-0">
                  <select class="form-select" (change)='setLineWeight($event)'>
                    @for (x of getSize(1, 20); track x) {
                      <option [value]="x" [selected]="selectedLineWeight === x">
                        {{x}}
                      </option>
                    }
                  </select>
                </div>
              </div>
            }
            @if (drawBtn === 'marker' || (editingShape === 'marker' && isShapeSelected())) {
              <div>
                <div class="row mx-0 form-group markers">
                  <label class="col-3 pr-0 col-form-label px-0">Style: </label>
                  <div class="col-4 ps-0">
                    <ng-select (change)="setMarker($event)" [ngModel]="(mapState$ | async).markerShape">
                      @for (opts of markerOptions; track opts) {
                        <ng-option [value]="opts">
                          <div class="measure-marker-icon">
                            <span class="{{opts}}"></span>
                          </div>
                        </ng-option>
                      }
                    </ng-select>
                  </div>
                </div>
                <div class="row mx-0 form-group markers">
                  <label class="col-3 pr-0 col-form-label px-0">Size: </label>
                  <div class="col-4 ps-0">
                    <select (change)='setMarkerSize($event)' class="form-select">
                      @for (x of getSize(5, 20); track x) {
                        <option [value]="x" [selected]="selectedMarkerSize === x">
                          {{x}}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            }
            <!-- measurements & conversions etc-->
            <!--(drawBtn === 'edit' && editingShape && editingShape !== 'AddText')-->
            @if (((drawBtn !== 'edit' && drawBtn !== 'AddText' && drawBtn !== 'cancel' && drawBtn !== 'labelmarker') || (drawBtn === 'edit' && editingShape && editingShape !== 'AddText' && editingShape !== 'cancel' && editingShape !== 'labelmarker' && isShapeSelected()))) {
              <div
                >
                <hr class="" />
                <div class="mb-3 form-check form-check-inline mx-0 d-flex justify-content-start ps-0">
                  <label class="form-check-label" for="showMeasureChkbox">Show measurements: </label>
                  <input type="checkbox" value="true" class="position-static form-check-input ml-2"
                    [ngModel]="(mapState$ | async).showMeasure" id="showMeasureChkbox"
                    (change)='toggleMeasureLabel($event)'>
                  </div>
                  @if ((mapState$ | async).showMeasure) {
                    <div class="measurements">
                      @if (drawBtn === 'polygon' || editingShape === 'Polygon' || drawBtn === 'circle'  || editingShape === 'circle') {
                        <div class="form-group row mx-0"
                          >
                          <label class="col-3 pr-0 col-form-label px-0">Area:</label>
                          <div class="col-5">
                            <ng-select [items]="applicationState.unitsArea" bindLabel="unit"
                              (change)="changeMeasureAreaUnit($event)" [ngModel]="(mapState$ | async).selectedAreaUnit"
                              [clearable]="false" [searchable]="false">
                            </ng-select>
                          </div>
                        </div>
                      }
                      @if (drawBtn === 'line' || editingShape === 'LineString') {
                        <div class="form-group row mx-0">
                          <label class="col-3 pr-0 col-form-label px-0">Length:</label>
                          <div class="col-5">
                            <ng-select [items]="applicationState.unitsLinear" bindLabel="unit"
                              (change)="changeMeasureLinearUnit($event)" [ngModel]="(mapState$ | async).selectedLinearUnit"
                              [clearable]="false" [searchable]="false">
                            </ng-select>
                          </div>
                        </div>
                      }
                      @if (drawBtn === 'marker' || editingShape === 'marker') {
                        <div class="form-group row mx-0">
                          <label class="col-3 pr-0 col-form-label px-0">Coords:</label>
                          <div class="col-5 px-0">
                            <ng-select [ngModel]="(mapState$ | async).measureUseUTM" (change)="setUseUtm($event)"
                              [clearable]="false" [searchable]="false">
                              <ng-option [value]="false">Lat / Lng</ng-option>
                              <ng-option [value]="true">UTM</ng-option>
                            </ng-select>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              </div>
            </div>
          </div>
          <div id="EngDrawDiv" class="panel" 
            [class.fade]="application.toolboxStatus !== ToolboxStatus.EngDrawing || application.status !== ApplicationStatus.Toolbox">
            <div class="container py-2 px-0">
              <div class="pt-1">
                <div class="d-block title">
                  <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Engineering Drawing"
                    (click)="toggleEngDraw(application.toolboxStatus, true)">
                    <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                    <div class="d-inline-block mt-2 title-text">
                      Engineering Drawing
                    </div>
                  </button>
                </div>
              </div>
              <div class="form-group px-3 mt-2">
                <p>Click or draw a polygon on the map to retrieve Engineering Drawings for that location.</p>
                <p>Engineering Drawings open in a new window.</p>
                @if (!isDesktop) {
                  <div class="draw-buttons mt-3 d-flex">
                    <button type="button" class="btn btn-outline-secondary btn-rect" [class.on]="drawBtn === 'eng-polygon'"
                      (click)="toggleRect();" title="Draw a polygon" id="btn-rect">
                      <i class="fal fa-rectangle-portrait"></i>
                    </button>
                  </div>
                }
                <hr />
                <div class="row mx-0 mt-3">
                  <div class="search-field px-0">
                    <div [formGroup]="engSearchForm" class="engSearchform">
                      <div class="form-group">
                        <label>
                          If you know the drawing <strong>number(s)</strong> you are looking for, you can type it
                          below:
                        </label>
                        <input type="text" class="form-control" id="engDrawSearchNum" formControlName="engDrawSearchNum"
                          [ngbTypeahead]="engDrawSearchNum" [resultTemplate]="engSearch" [inputFormatter]="formatter"
                          (selectItem)="onSelectEng($event)" placeholder="AA000,AA001,AA002">
                          @if (this.engSearchForm.get('engDrawSearchNum').value) {
                            <button type="button"
                              class="clear-search engdrawNum float-right" (click)="onClearEngSearch('num')">
                              <i class="far fa-times-circle clear-search-icon"></i>
                            </button>
                          }
                          @if (searchingNum) {
                            <small class="mt-2">searching...</small>
                          }
                        </div>
                        <div class="form-group mt-4">
                          <label>
                            If you know the drawing <strong>project</strong> you are looking for, you can type it
                            below:
                          </label>
                          <input type="text" class="form-control" id="engDrawSearchProj" formControlName="engDrawSearchProj"
                            [ngbTypeahead]="engDrawSearchProj" [resultTemplate]="engSearch" [inputFormatter]="formatter"
                            (selectItem)="onSelectEng($event)">
                            @if (this.engSearchForm.get('engDrawSearchProj').value) {
                              <button type="button"
                                class="clear-search engdrawProj float-right" (click)="onClearEngSearch('proj')">
                                <i class="far fa-times-circle clear-search-icon"></i>
                              </button>
                            }
                            @if (searchingProj) {
                              <small class="mt-2">searching...</small>
                            }
                          </div>
                          <button type="button" class="btn btn-primary float-right mt-2" (click)="searchEng()"
                            id="btnSearchEng">
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="row mx-0 mt-3 d-none d-sm-block">
                      <a href="/edreports" target="_blank" class="lnk-ed-reports px-0">Engineering Drawings Reports</a><br />
                      <small class="px-0">Click here to view reports and statuses of outstanding engineering drawings and projects</small>
                    </div>
                  </div>
                </div>
              </div>
              <div id="PostingPlanDiv" class="panel" 
                [class.fade]="application.toolboxStatus !== ToolboxStatus.PostingPlans || application.status !== ApplicationStatus.Toolbox">
                <div class="container py-2 px-0">
                  <div class="pt-1">
                    <div class="d-block title">
                      <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Posting Plans"
                        (click)="togglePostingPlans(application.toolboxStatus, true)">
                        <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                        <div class="d-inline-block mt-2 title-text">
                          Legal Plans
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="form-group px-3 mt-2">
                    <p>
                      Click on the map and draw a polygon to retrieve posting plans for that location. Please note that the map
                      search will return <strong>posting plan</strong> results
                      <b>only</b>.
                    </p>
                    <p>Posting plans open in a new window.</p>
                    @if (!isDesktop) {
                      <div class="draw-buttons mt-3 d-flex">
                        <button type="button" class="btn btn-outline-secondary btn-rect" [class.on]="drawBtn === 'eng-polygon'"
                          (click)="toggleRect();" title="Draw a polygon" id="btn-rect">
                          <i class="fal fa-rectangle-portrait"></i>
                        </button>
                      </div>
                    }
                    <hr />
                    <div class="row mx-0 mt-3">
                      <div class="search-field">
                        <div [formGroup]="ppSearchForm" class="ppSearchform">
                          <div class="form-group">
                            <label>
                              For all legal plans, please use the search box. If you know the <strong>legal plan number</strong>
                              you are looking for, you can type it
                              below:
                            </label>
                            <input type="text" class="form-control" id="ppSearchNum" formControlName="ppSearchNum"
                              [ngbTypeahead]="ppSearchNum" [resultTemplate]="engSearch" [inputFormatter]="formatter"
                              (selectItem)="onSelectPP($event)" placeholder="EPP00000, LMP00001">
                              @if (this.ppSearchForm.get('ppSearchNum').value) {
                                <button type="button"
                                  class="clear-search ppNum float-right" (click)="onClearPPSearch('num')">
                                  <i class="far fa-times-circle clear-search-icon"></i>
                                </button>
                              }
                              @if (searchingNum) {
                                <small class="mt-2">searching...</small>
                              }
                            </div>
                            <button type="button" class="btn btn-primary float-right mt-2" (click)="searchPPNum()"
                              id="btnSearchPP">
                              Search
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="CCTVDiv" class="panel" 
                  [class.fade]="application.toolboxStatus !== ToolboxStatus.CCTV || application.status !== ApplicationStatus.Toolbox">
                  <div class="container py-2 px-0">
                    <div class="pt-1">
                      <div class="d-block title">
                        <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close CCTV Inspections"
                          (click)="toggleCCTV(application.toolboxStatus)">
                          <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                          <div class="d-inline-block mt-2 title-text">CCTV Inspections</div>
                        </button>
                      </div>
                    </div>
                    <div class="form-group px-3 mt-2">
                      <p>Click on a sanitary main to see details.</p>
                      @if (!isDesktop) {
                        <p>
                          <strong>Mobile Users</strong>: click on the <i class="far fa-toolbox"></i> to
                          collapse this panel,
                        click on "< CCTV Inspections" to turn off CCTV Inspections </p>
                      }
                      <hr />
                      <div class="row mx-0 mt-3">
                        <div class="search-field">
                          <div [formGroup]="cctvSearchForm" class="engSearchform">
                            <div class="form-group">
                              <label>Or enter the Asset ID below:</label>
                              <input type="text" class="form-control" id="cctvSearch" formControlName="cctvSearch">
                              @if (this.cctvSearchForm.get('cctvSearch').value.length > 5) {
                                <button type="button"
                                  class="clear-search engdrawNum float-right" (click)="onClearCCTVSearch()">
                                  <i class="far fa-times-circle clear-search-icon"></i>
                                </button>
                              }
                              @if (searchingNum) {
                                <small class="mt-2">searching...</small>
                              }
                            </div>
                            <button type="button" class="btn btn-primary float-right mt-2" (click)="searchCCTV()"
                              id="btnSearchCCTV">
                              Search
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="mailMerge" class="panel" 
                  [class.fade]="application.toolboxStatus !== ToolboxStatus.MailMerge || application.status !== ApplicationStatus.Toolbox">
                  <div class="container py-2 px-0">
                    <div class="pt-1">
                      <div class="d-block title">
                        <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Mailing Labels"
                          (click)="toggleMailMerge()">
                          <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                          <div class="d-inline-block mt-2 title-text">Mailing Labels</div>
                        </button>
                      </div>
                    </div>
                    <app-dnv-mailmerge [sliderOptions]="bufferSliderOptions" (mailLabelSelectEmitter)="onMailLabelSelect($event)"
                      (mailLabelDrawEmitter)="onMailLabelDraw($event)" [mailMergeState]="toolboxMailMergeState"
                      (mailBufferEmitter)="onMailMergeBufferChange($event)" (mailLabelClearEmitter)="onMailLabelClearEmitter()"
                      (downloadEmitter)="downloadMailLabels($event)"
                      (mailLabelOptionsEmitter)="onMailLabelOptionsEmitter($event)">
                    </app-dnv-mailmerge>
                  </div>
                </div>
                <div id="historicalAerials" class="panel" 
                  [class.fade]="application.toolboxStatus !== ToolboxStatus.HistoricalAerials || application.status !== ApplicationStatus.Toolbox">
                  <div class="container py-2 px-0">
                    <div class="pt-1">
                      <div class="d-block title">
                        <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Historical Aerials"
                          (click)="toggleHistoricalAerials()">
                          <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                          <div class="d-inline-block mt-2 title-text">Historical Aerials</div>
                        </button>
                      </div>
                    </div>
                    <ngx-slider [formControl]="historicalSlider" [options]="haSliderOptions" (valueChange)="getHASliderValue()"
                      (mouseup)="getHASliderValue()">
                    </ngx-slider>
                  </div>
                </div>
                <div id="assetFinder" class="panel" 
                  [class.fade]="application.toolboxStatus !== ToolboxStatus.AssetFinder || application.status !== ApplicationStatus.Toolbox">
                  <div class="container py-2 px-0">
                    <div class="pt-1">
                      <div class="d-block title">
                        <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Asset Finder"
                          (click)="toggleAssetFinder()">
                          <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                          <div class="d-inline-block mt-2 title-text">Asset Finder</div>
                        </button>
                      </div>
                    </div>
                    <div class="form-group px-3 mt-2">
                      <div class="row mx-0 mt-3">
                        <div class="search-field">
                          <div [formGroup]="assetSearchForm" class="assetSearchForm">
                            <div class="form-group">
                              <label class="col-form-label">
                                Search for an asset:
                              </label>
                              <input type="text" class="form-control" id="assetSearch" formControlName="assetSearch"
                                [ngbTypeahead]="assetSearch" [resultTemplate]="assetSearchTemplate"
                                [inputFormatter]="assetFormatter" (selectItem)="onSelectAsset($event)" placeholder="AAAAA00000">
                                @if (this.assetSearchForm.get('assetSearch').value) {
                                  <button type="button"
                                    class="clear-search assetSearch float-right" (click)="onClearAssetSearch()">
                                    <i class="far fa-times-circle clear-search-icon"></i>
                                  </button>
                                }
                              </div>
                              @if (searchingAsset) {
                                <small class="mt-2">searching...</small>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="wmrp" class="panel" 
                    [class.fade]="application.toolboxStatus !== ToolboxStatus.WMRP || application.status !== ApplicationStatus.Toolbox">
                    @if (!showAnalysisStatus && !showAnalysisSchedules) {
                      <div class="container py-2 px-0">
                        <div class="pt-1">
                          <div class="d-block title">
                            <button class="btn btn-link float-left w-100 text-start p-0 d-flex wrap" title="Close WMRP"
                              (click)="toggleWMRP()">
                              <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                              <div class="d-inline-block mt-2 title-text">Water Main Replacement Program</div>
                            </button>
                          </div>
                        </div>
                        <div class="button-group">
                          <h6 class="m-3">Open Results</h6>
                          <div class="row mx-3 justify-content-between d-flex">
                            <button type="button" class="btn btn-outline-primary btn-square" (click)="toggleAnalysisStatus()"
                              title="Open Results">
                              <i class="fa-light fa-folder-open fa-2xl"></i>
                            </button>
                            <div class="wmrp-text">Open results from a previous analysis run.</div>
                          </div>
                        </div>
                        <hr />
                        @if (isWMRP('WMRP USER')) {
                          <div class="button-group">
                            <h6 class="m-3">New Analysis (Default Settings)</h6>
                            <div class="row mx-3 justify-content-between d-flex">
                              <button type="button" class="btn btn-outline-primary btn-square" (click)="toggleWMRPConditions()"
                                title="New Analysis (Default Settings)">
                                <i class="fa-light fa-file-plus fa-2xl"></i>
                              </button>
                              <div class="wmrp-text">Define parameters and run a new WMRP analysis.</div>
                            </div>
                          </div>
                        }
                        @if (isWMRP('WMRP USER')) {
                          <hr />
                        }
                        @if (isWMRP('WMRP USER')) {
                          <div class="button-group">
                            <h6 class="m-3">New Analysis (From Template)</h6>
                            @for (t of templates; track t; let i = $index) {
                              <div class="row mx-3 justify-content-between d-flex mb-3"
                                [formGroup]="wmrpForm">
                                <ng-container formArrayName="paramSet">
                                  <button type="button" class="btn btn-outline-primary btn-square" (click)="toggleWMRPConditions(true, i)"
                                    title="New Analysis (From Template)">
                                    <i class="fa-light fa-copy fa-2xl"></i>
                                  </button>
                                  <div class="wmrp-text" [formGroupName]="i">
                                    {{t.name}}<br /> created by {{t.userName}}
                                    <input type="hidden" formControlName="paramSetId">
                                  </div>
                                </ng-container>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                    @if (showAnalysisStatus) {
                      <div class="analysis-status" [style.height.px]="panelHeight">
                        <div class="d-block title wmrp-title">
                          <button class="btn btn-link float-left w-100 text-start p-0 d-flex wrap" title="Close WMRP"
                            (click)="toggleAnalysisStatus()">
                            <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                            <div class="d-inline-block mt-2 title-text">Water Main Replacement Program</div>
                          </button>
                        </div>
                        <div class="input-wrapper" [formGroup]="analysisTitleForm">
                          @for (runDetails of (wmrpRecentAnalyses$ | async); track runDetails; let i = $index) {
                            <div
                              class="p-3 border border-left-0 border-right-0 border-top-0 wmrp-job-details wmrp-details"
                              [class.selected]="analysisGuid && analysisGuid === runDetails.fmeReference">
                              <div class="d-flex flex-row justify-content-between detail">
                                <div class="text-block">
                                  <div class="row mx-0 py-0 d-block">
                                    @if (isWMRP('WMRP USER') && (runDetails.title === null || runDetails.title?.length === 0)) {
                                      <button class="btn btn-link btn-add-title btn-icon d-block"
                                        (click)="openWMRPTitle(wmrpTitleModal, runDetails.fmeJobId, runDetails.title, 'analysis')"
                                        title="Add a title for analysis">
                                        <i class="fa-solid fa-plus"></i> Add a title
                                      </button>
                                    }
                                    <button type="button" class="btn btn-link text-start p-0 mr-2"
                                      (click)="selectRun(runDetails.fmeReference)"
                                      [attr.disabled]="runDetails.status.toLowerCase() !== 'success' ? true : null">
                      <div class="analysis-title" [class.fixed-width]="runDetails.title?.length > 0" [attr.title]="runDetails.title ? runDetails.title : 'Analysis ID ' +
                      runDetails.fmeJobId">{{runDetails.title ? runDetails.title : "Analysis ID " +
                                      runDetails.fmeJobId + ' (' +runDetails.schedulesCount +' schedules)'}}</div>
                                    </button>
                                    @if (isWMRP('WMRP USER') && runDetails.title?.length > 0) {
                                      <button
                                        class="btn btn-link btn-edit-title btn-icon" title="Edit the title of this analysis"
                                        (click)="openWMRPTitle(wmrpTitleModal, runDetails.fmeJobId, runDetails.title, 'analysis')">
                                        <i class="fa-solid fa-pen-to-square"></i>
                                      </button>
                                    }
                                  </div>
                                  @if (runDetails.title && runDetails.title.length > 0) {
                                    <div
                                      [title]="'Analysis ID ' +runDetails.fmeJobId">Analysis ID
                                      {{runDetails.fmeJobId}} ({{runDetails.schedulesCount}} schedules)
                                    </div>
                                  }
                                  <div>{{runDetails.createdAt | date: 'MM-dd-yyyy, hh:mm a'}}</div>
                                  <div class="row mx-0 mt-2">
                                    @if (isWMRP('WMRP USER')) {
                                      <button class="btn btn-icon"
                                        (click)="confirmDeleteAnalysisRun(runDetails.fmeJobId, confirmDelAnalysis)"
                                        title="Delete this analysis run">
                                        <i class="fa-solid fa-trash"></i>
                                      </button>
                                    }
                                    @if (runDetails.status==='SUCCESS') {
                                      <button type="button" class="btn btn-link btn-icon"
                                        (click)="shareLink(runDetails.fmeReference)" title="Share this analysis">
                                        <i class="fa-solid fa-share-nodes"></i>
                                      </button>
                                    }
                                  </div>
                                </div>
                                <div class=" m-3" title="{{runDetails.status}}">
                                  @if (checkFMEStatus(runDetails.status) === 'running') {
                                    <i class="fa-duotone fa-spinner-third fa-spin fa-2xl"
                                    ></i>
                                  }
                                  @if (checkFMEStatus(runDetails.status) === 'queued') {
                                    <div id="hourglass" class="fa-stack fa-2xl">
                                      <i class="fa fa-stack-1x fa-hourglass-start"></i>
                                      <i class="fa fa-stack-1x fa-hourglass-half"></i>
                                      <i class="fa fa-stack-1x fa-hourglass-end"></i>
                                      <i class="fa fa-stack-1x fa-hourglass-end"></i>
                                      <i class="fa fa-stack-1x fa-hourglass-o"></i>
                                    </div>
                                  }
                                  @if (checkFMEStatus(runDetails.status) === 'success') {
                                    <i class="fa-sharp fa-solid fa-circle-check fa-2xl"
                                    ></i>
                                  }
                                  @if (checkFMEStatus(runDetails.status) === 'pulled') {
                                    <i class="fa-solid fa-circle-notch fa-spin fa-2xl"
                                    style="--fa-animation-duration: 5s;"></i>
                                  }
                                  @if (checkFMEStatus(runDetails.status) === 'failed') {
                                    <i class="fa-regular fa-circle-xmark fa-2xl"
                                    ></i>
                                  }
                                </div>
                              </div>
                              @if (checkFMEStatus(runDetails.status) === 'queued' || checkFMEStatus(runDetails.status) === 'running' || checkFMEStatus(runDetails.status) === 'pulled') {
                                <div class="progress d-block"
                                  style="position: relative;">
                                  <div class="progress-bar progress-bar-striped indeterminate">
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (showAnalysisSchedules) {
                      <div class="panel analysis-results" [style.height.px]="panelHeight">
                        <div class="d-block title">
                          <button class="btn btn-link float-left w-100 text-start p-0 d-flex wrap" title="Close WMRP"
                            (click)="toggleAnalysisSchedule(false, true)">
                            <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                            <div class="d-inline-block mt-2 title-text">Water Main Replacement Program</div>
                          </button>
                        </div>
                        <div>
                          <dnv-layer [layerState]="(wmrpState$ | async)" [mapState]="mapState$ | async"
                            (onSetAvailableLayer)="setAvailableLayer($event)" (onSetActiveLayer)="setActiveLayer($event)"
                            (onLayersOrdered)="onLayersOrdered($event)" (onToggleShowFilterPanel)="onToggleShowFilterPanel($event)"
                            [showFilterButton]="true" [showHideLayerButton]="true" (onToggleExpand)="onToggleExpand($event)"
                            (onHideLayer)="onHideLayer($event)" (onHideFeatureLayer)="onHideFeatureLayer($event)"
                            (onClearActiveLayer)="onClearActiveLayer($event)" (onSetOpacity)="onSetOpacity($event)"
                            (filterAOI)="onFilterAOI($event)">
                          </dnv-layer>
                          <!-- <button *ngIf="replacementScheduleExists" type="button" class="btn btn-outline-primary" (click)="editReplacementSchedule(replacementSchedule)">Edit Replacement Schedule</button> -->
                          <div class="d-flex justify-content-between border border-left-0 border-right-0 border-bottom-0">
                            <div>
                              <h6 class="p-3 mb-0 font-weight-bold schedule">
                                Schedules for Analysis ID {{selectedRun.fmeJobId}}
                              </h6>
                              @if ((wmrpState$ | async).replacementSchedules.length === 0) {
                                <div class="px-3">
                                  There are no
                                  schedules
                                </div>
                              }
                            </div>
                            @if (isWMRP('WMRP USER')) {
                              <div>
                                <button type="button" class="btn btn-outline-primary mt-3 btn-sm mr-2"
                                  (click)="openSchedule(replacementSchedule)" title="Create Replacement Schedule">
                                  New
                                </button>
                              </div>
                            }
                          </div>
                          @for (details of (wmrpState$ | async).replacementSchedules; track details; let i = $index) {
                            <div
                              class="p-3 border border-left-0 border-right-0 wmrp-schedule-details wmrp-details"
                              [class.border-top-0]="i > 0"
                              [class.selected]="(scheduleGuid && scheduleGuid === details.fmeReference_Schedule) || ((wmrpState$ | async).selectedReplacementSchedule && (wmrpState$ | async).selectedReplacementSchedule?.fmeReference_Schedule == details.fmeReference_Schedule)">
                              <div class="d-flex flex-row justify-content-between">
                                <div class="text-block">
                                  @if (isWMRP('WMRP USER') && (details.title && details.title.length === 0 || details.title === null)) {
                                    <button class="btn btn-link btn-add-title btn-icon d-block"
                                      title="Add a title for schedule"
                                      (click)="openWMRPTitle(wmrpTitleModal, details.fmeJobId, details.title, 'schedule')">
                                      <i class="fa-solid fa-plus"></i> Add a title
                                    </button>
                                  }
                                  <div>
                                    <button type="button" class="btn btn-link text-start p-0" (click)="selectSchedule(details)"
                                      [attr.disabled]="details.status.toLowerCase() !== 'success' ? true : null">
                                      @if (details.title === null || (details.title && details.title.length === 0)) {
                                        <div>Schedule ID
                                        {{details.fmeJobId}}</div>
                                      }
                                      @if (details.title && details.title.length > 0) {
                                        <div class="mr-2">{{details.title}}</div>
                                      }
                                    </button>
                                    @if (isWMRP('WMRP USER') && details.title &&  details.title?.length > 0) {
                                      <button
                                        class="btn btn-link btn-edit-title btn-icon" title="Edit the title of this schedule"
                                        (click)="openWMRPTitle(wmrpTitleModal, details.fmeJobId, details.title, 'schedule')">
                                        <i class="fa-solid fa-pen-to-square"></i>
                                      </button>
                                    }
                                    @if (details.title && details.title.length > 0) {
                                      <div [title]="'Schedule ID ' + details.fmeJobId">
                                        Schedule ID
                                        {{details.fmeJobId}}
                                      </div>
                                    }
                                  </div>
                                  <div>{{details.createdAt | date: 'MM-dd-yyyy, hh:mm a'}}</div>
                                  <div>
                                    @if (isWMRP('WMRP USER')) {
                                      <button class="btn btn-icon"
                                        (click)="confirmDeleteScheduleRun(details.fmeJobId, confirmDelSchedule)"
                                        title="Delete this schedule run">
                                        <i class="fa-solid fa-trash"></i>
                                      </button>
                                    }
                                    @if (details.status==='SUCCESS') {
                                      <button type="button" class="btn btn-link btn-icon"
                                        (click)="shareLink(details.fmeReference_Schedule)" title="Share this schedule">
                                        <i class="fa-solid fa-share-nodes"></i>
                                      </button>
                                    }
                                  </div>
                                </div>
                                <div class=" m-3" title="{{details.status}}">
                                  @if (checkFMEStatus(details.status) === 'running') {
                                    <i class="fa-duotone fa-spinner-third fa-spin fa-2xl"
                                    ></i>
                                  }
                                  @if (checkFMEStatus(details.status) === 'queued') {
                                    <div id="hourglass" class="fa-stack fa-2xl">
                                      <i class="fa fa-stack-1x fa-hourglass-start"></i>
                                      <i class="fa fa-stack-1x fa-hourglass-half"></i>
                                      <i class="fa fa-stack-1x fa-hourglass-end"></i>
                                      <i class="fa fa-stack-1x fa-hourglass-end"></i>
                                      <i class="fa fa-stack-1x fa-hourglass-o"></i>
                                    </div>
                                  }
                                  @if (checkFMEStatus(details.status) === 'success') {
                                    <i class="fa-sharp fa-solid fa-circle-check fa-2xl"
                                    ></i>
                                  }
                                  @if (checkFMEStatus(details.status) === 'pulled') {
                                    <i class="fa-solid fa-circle-notch fa-spin fa-2xl"
                                    style="--fa-animation-duration: 5s;"></i>
                                  }
                                  @if (checkFMEStatus(details.status) === 'failed') {
                                    <i class="fa-regular fa-circle-xmark fa-2xl"></i>
                                  }
                                </div>
                              </div>
                              @if (checkFMEStatus(details.status) === 'queued' || checkFMEStatus(details.status) === 'running' || checkFMEStatus(details.status) === 'pulled') {
                                <div class="progress d-block"
                                  style="position: relative;">
                                  <div class="progress-bar progress-bar-striped indeterminate">
                                  </div>
                                </div>
                              }
                              <div class="row d-flex justify-content-between mx-0">
                                <button
                                  class="btn btn-link p-0 show text-start d-flex justify-content-start text-decoration-none btn-params collapsed"
                                  type="button" data-bs-toggle="collapse" attr.data-bs-target="#job{{details.id}}" aria-expanded="false"
                                  attr.aria-controls="#job{{details.id}}">
                                  <span>Parameters</span>
                                  <i class="fa-solid fa-chevron-down"></i>
                                  <i class="fa-solid fa-chevron-up"></i>
                                </button>
                              </div>
                              <div id="job{{details.id}}" class="schedule-params collapse">
                                <div class="card card-body p-2">
                                  <dl class="mb-0">
                                    <dt>Analysis Value Enabled:</dt>
                                    <dd class="text-capitalize">{{details.analysisValueEnabled}}</dd>
                                    <dt>End of Life Enabled:</dt>
                                    <dd class="text-capitalize">{{details.endOfLifeEnabled}}</dd>
                                    <dt>Number of Breaks Enabled:</dt>
                                    <dd class="text-capitalize">{{details.numBreaksEnabled}}</dd>
                                    <dt>Exclusion Layer Enabled:</dt>
                                    <dd class="text-capitalize">{{details.exclusionLayerEnabled}}</dd>
                                    <dt>Replacement Metres Per Year:</dt>
                                    <dd>{{details.replacementMetresPerYear}}</dd>
                                    <dt>Start Year:</dt>
                                    <dd>{{details.startYear}}</dd>
                                    <dt>End Year:</dt>
                                    <dd>{{details.endYear}}</dd>
                                  </dl>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <div id="layerFilterDiv" class="secondary-panel"
                      [class.fade]="!(application.toolboxStatus === ToolboxStatus.WMRP && (layerState$ | async).showFilterPanel)"
                      style="position: fixed; top:auto;">
                      <div class="pt-1 title-wrapper">
                        <div class="d-block title" (click)="hideFilterPanel()">
                          <button class="btn btn-link float-left" title="Close Layer Filter">
                            <i class="fas fa-chevron-left fa-sm"></i>
                          </button>
                          <div class="d-inline-block filters-title title-text" title="Layer Filter">Layer Filter</div>
                        </div>
                        <dnv-layer-filter [layerState]="layerState$ | async" [headerHeight]="headerHeightSecondary"
                          [link]="application.link" [hiddenFields]="wmrpHiddenFields" (updateFilter)="onUpdateFilter($event)"
                          (zoomToFeatures)="onZoomToFeatures($event)">
                        </dnv-layer-filter>
                      </div>
                    </div>
                  </div>
                  <div id="populationCalculator" class="panel" 
                    [class.fade]="application.toolboxStatus !== ToolboxStatus.PopulationCalculator || application.status !== ApplicationStatus.Toolbox">
                    <div class="container py-2 px-0">
                      <div class="pt-1">
                        <div class="d-block title">
                          <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Population Calculator"
                            (click)="togglePopulation()">
                            <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                            <div class="d-inline-block mt-2 title-text">Population Calculator</div>
                          </button>
                        </div>
                      </div>
                      <app-dnv-population [populationState]="populationState" (populationSelectEmitter)="onPopulationSelect()"
                        (populationDrawEmitter)="onPopulationDraw()" (populationClearEmitter)="onPopulationClear()">
                      </app-dnv-population>
                      <div class="border-bottom"></div>
                      <p class="px-3 mt-2">
                        The population calculations originate from the number of current residential units
                        multiplied by population ratios based on the 2016 Census of Population conducted by Statistics Canada and
                        are estimates
                        only. For single-family dwellings, population values are based on the average neighborhood-specific
                        populations. For
                        multi-family dwellings, population values are universally applied across the entire district using specified
                        values derived by Statistics Canadas survey for the District of North Vancouver as a whole.
                      </p>
                      @if (populationState?.buildings?.length > 0) {
                        <div class="px-3 mt-2 border-top">
                          <div class="key-pair">
                            <span class="label">Population (Estimated):</span>
                            <span>{{ populationTotal.toFixed(2) }}</span>
                          </div>
                          <div class="key-pair">
                            <span class="label">Number of buildings:</span>
                            <span>{{populationState.buildings?.length}}</span>
                          </div>
                          @if (getDensity() > 0) {
                            <div class="key-pair">
                              <span class="label">Density:</span>
                              <span>{{getDensity()}} per sq km</span>
                            </div>
                          }
                          @if (applicationState.measurements.msq > 0) {
                            <div class="key-pair">
                              <span class="label">Area:</span>
                              <span>{{applicationState.measurements.msq.toFixed(2)}} sq m</span>
                              <span>({{applicationState.measurements.kmsq.toFixed(2)}} sq km)</span>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div id="ToolsDiv" class="panel" 
                    [class.mobile-hidden]="mapState.editingFeature" [class.fade]="hideTools()">
                    <div class="container py-2 px-0">
                      <div class="pt-1">
                        <div class="d-block title">
                          <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Tools"
                            (click)="toggleToolbox(application.status)">
                            <div class="chevron-wrapper">
                              <i class="fas fa-chevron-left fa-sm"></i>
                            </div>
                            <div class="d-inline-block mt-2 title-text">Tools</div>
                          </button>
                        </div>
                      </div>
                      <div class="tools-padding">
                        <div class="tool-item">
                          <button class="btn btn-link btn-prop-info" title="property information" (click)="togglePropertyInfo()"
                            [class.on]="applicationState.toolboxStatus === ToolboxStatus.PropertyInfo" id="btnPropInfo">
                            <span class="icon-wrapper"><i class="far fa-home-alt"></i></span>
                            Property Information
                          </button>
                        </div>
                        <div class="tool-item">
                          <button class="btn btn-link btn-prop-info" title="edit features" (click)="toggleEditFeatures()"
                            [class.on]="applicationState.toolboxStatus === ToolboxStatus.EditFeatures" id="btnEditFeatures"
                            [disabled]="(layerState$ | async).layers.length === 0 && !applicationState.editPermisison">
                            <span class="icon-wrapper"><i class="far fa-edit"></i></span>
                            Edit Features
                          </button>
                        </div>
                        <div class="tool-item">
                          <button id="btnEngDrawing" type="button" class="btn btn-link"
                            [class.active-btn]="application.toolboxStatus === ToolboxStatus.EngDrawing" title="Engineering Drawings"
                            (click)="toggleEngDraw(application.toolboxStatus)">
                            <span class="icon-wrapper"><i class="far fa-drafting-compass"></i></span>
                            Engineering Drawings
                          </button>
                        </div>
                        <div class="tool-item">
                          <button id="btnPostingPlans" type="button" class="btn btn-link"
                            [class.active-btn]="application.toolboxStatus === ToolboxStatus.PostingPlans" title="Legal Plans"
                            (click)="togglePostingPlans(application.toolboxStatus)">
                            <span class="icon-wrapper"><i class="far fa-draw-square"></i></span>
                            Legal Plans
                          </button>
                        </div>
                        <div class="tool-item">
                          <button id="btnCCTV" type="button" class="btn btn-link"
                            [class.on]="application.toolboxStatus === ToolboxStatus.CCTV" title="CCTV Inspections"
                            (click)="toggleCCTV(application.toolboxStatus)">
                            <span class="icon-wrapper">
                              <i class="fas fa-photo-video"></i>
                            </span>
                            CCTV Inspections
                          </button>
                        </div>
                        <div class="tool-item">
                          <button class="btn btn-link btn-svc-conn" title="Service Connections" (click)="toggleSvcConn()"
                            [class.on]="application.toolboxStatus === ToolboxStatus.ServiceConnections">
                            <span class="icon-wrapper"><i class="far fa-faucet-drip"></i></span>
                            Service Connections
                          </button>
                        </div>
                        @if (isDesktop) {
                          <div class="tool-item">
                            <button class="btn btn-link btn-mail-merge" title="Mailing Labels" (click)="toggleMailMerge()"
                              [class.on]="application.toolboxStatus === ToolboxStatus.MailMerge">
                              <span class="icon-wrapper"><i class="fal fa-mail-bulk"></i></span>
                              Mailing Labels
                            </button>
                          </div>
                        }
                        <div class="tool-item">
                          <button class="btn btn-link btn-historical" title="Historical Aerials" (click)="toggleHistoricalAerials()"
                            [class.on]="application.toolboxStatus === ToolboxStatus.HistoricalAerials">
                            <span class="icon-wrapper"><i class="fal fa-history"></i></span>
                            Historical Aerials
                          </button>
                        </div>
                        <div class="tool-item">
                          <button class="btn btn-link btn-assetFinder" title="Asset Finder" (click)="toggleAssetFinder()"
                            [class.on]="application.toolboxStatus === ToolboxStatus.AssetFinder"
                            [disabled]="(layerState$ | async).layers.length === 0">
                            <span class="icon-wrapper"><i class="far fa-search"></i></span>
                            Asset Finder
                          </button>
                        </div>
                        @if (isDesktop && (isWMRP('WMRP USER') || isWMRP('WMRP READER'))) {
                          <div class="tool-item wmrp">
                            <button class="btn btn-link btn-wmrp" title="Water Main Replacement Program"
                              [disabled]="(layerState$ | async).layers.length === 0"
                              [class.on]="application.toolboxStatus === ToolboxStatus.WMRP" (click)="toggleWMRP()">
                              <span class="icon-wrapper"><i class="fa-thin fa-pipe-section"></i></span>
                              Water Main Replacement Program
                            </button>
                          </div>
                        }
                        <div class="tool-item">
                          <button class="btn btn-link btn-assetFinder" title="Population Calculator" (click)="togglePopulation()"
                            [class.on]="application.toolboxStatus === ToolboxStatus.PopulationCalcuator">
                            <span class="icon-wrapper"><i class="fa-solid fa-people-group"></i></span>
                            Population Calculator
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if ((application$ | async).toolboxStatus !== ToolboxStatus.CCTV && (application$ | async).toolboxStatus !== ToolboxStatus.EditFeatures) {
                    <div
                      >
                      @if ((mapState.surroundingFeatureList && mapState.surroundingFeatureList.length > 0) || (mapState.selectedFeature && mapState.selectedFeature.length > 0)) {
                        <div id="rightPanel" class="rightPanel"
                          >
                          <dnv-feature-info [mapState]="mapState$ | async" [layerState]="layerState$ | async"
                            [wmrpState]="wmrpState$ | async" [kvSections]="(application$ | async).kvSections"
                            [headerHeight]="headerHeight" [panelHeight]="panelHeight"
                            [relatedRecords]="(application$ | async).relatedRecords"
                            [cctvInspections]="(application$ | async).cctvInspections" (highlightFeature)="highlightFeature($event)"
                            (selectFeature)="selectEditFeature($event)" (closePanel)="closeFeatureInformation()"
                            [selectedCCTVInspection]="applicationState.selectedCctvInspection" [inspHeight]="inspectionHeight"
                            [cctvNotes]="applicationState.cctvNotes" [excludeFeaturesList]="(mapState$ |async).excludeFeatureInfo"
                            [selectedFeatureAttachments]="(application$ | async).selectedFeatureAttachments"
                            [galleryOptions]="(application$ | async).galleryOptions"
                            [externalFeature]="(application$ | async).externalFeature"
                            [alertHidden]="(application$ | async).alertHidden" [appSettings]="applicationState.appSettings"
                            [scheduleYears]="scheduleYears" [isWMRP]="applicationState.toolboxStatus === ToolboxStatus.WMRP"
                            (emitCCTVInspection)="onSelectCctv($event)" (exportInspectionsEmitter)="onExportInspections($event)"
                            [validWmrpFeatureLayer]="true" (emitAssetToWmrp)="updateSchedule($event)">
                          </dnv-feature-info>
                        </div>
                      }
                    </div>
                  }
                  <div id="EditFeaturesDiv" class="panel" 
                    [class.mobile-hidden]="mapState.editingFeature"
                    [class.fade]="application.toolboxStatus !== ToolboxStatus.EditFeatures || application.status !== ApplicationStatus.Toolbox">
                    <div class="container py-2 px-0">
                      <div class="pt-1">
                        <div class="d-block title">
                          <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close Edit Features"
                            (click)="toggleEditFeatures(application.toolboxStatus)">
                            <div class="chevron-wrapper"><i class="fas fa-chevron-left fa-sm"></i></div>
                            <div class="d-inline-block mt-2 title-text">Edit Features</div>
                          </button>
                        </div>
                      </div>
                      @if ((application$ | async).editPermission) {
                        <div class="form-group px-2 mt-2">
                          @for (ef of (application$ | async).editPermission; track ef) {
                            <div>
                              <h3>{{ef.toolname}}</h3>
                              <div class="tools-padding px-0">
                                @for (lyr of ef.editableLayers; track lyr) {
                                  <div class="tool-item">
                                    <button type="button" class="btn btn-link btn-edit-feature" (click)="editFeatureClick(lyr)">
                                      <span class="icon-wrapper">
                                        @if (lyr.shape === 'esriGeometryPoint') {
                                          <i class="fad fa-share-alt"
                                          style="--fa-secondary-opacity: 0"></i>
                                        }
                                        @if (lyr.shape === 'esriGeometryPolygon') {
                                          <i class="fal fa-draw-polygon"></i>
                                        }
                                        @if (lyr.shape === 'esriGeometryPolyline') {
                                          <i class="far fa-wave-sine"></i>
                                        }
                                      </span> 
                                      <span>{{lyr.featureLayerName}}</span>
                                    </button>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  @if (application.toolboxStatus === ToolboxStatus.EditFeatures && application.status === ApplicationStatus.Toolbox) {
                    <div
                      class="editFeaturesWrapper" [class.mobile-hidden]="mapState.editingFeature">
                      <app-edit-features [editFeature]="(application$ | async).editFeature" [headerHeight]="headerHeight"
                        [panelHeight]="panelHeight" class="edit-features-steps" [mapState]="(mapState$ | async)"
                        [selectedFeature]="(mapState$ | async).selectedFeature" [layerState]="layerState$ | async"
                        [featureAdded]="featureAdded" [maxAsset]="(application$ | async).maxAsset"
                        [showSpinner]="(application$ | async).spinner" [snapAsset]="(mapState$| async).snapAsset"
                        [fields]="(application$ | async).editFeatureFields"
                        [requiredFields]="(application$ | async).editRequiredFields"
                        [readOnlyFields]="(application$ | async).editReadOnlyFields" [isDesktop]="isDesktop"
                        (highlightFeature)="highlightFeature($event)" [editingFeature]="mapState.editingFeature"
                        [showLayers]="(application$ | async).editFeatureShowActiveLayer" (selectFeature)="onSelectFeatureEmit($event)"
                        (featureTypeEmitter)="setFeatureType($event)" (saveFeatureEmitter)="saveEditFeature($event)"
                        (deleteFeatureEmitter)="deleteNewFeature()" (confirmDeleteEmitter)="deleteFeature($event)"
                        (revertGeometryEmitter)="revertGeometry()" (setEditFeaturesEmitter)="enableEditFeatures($event)"
                        (newFeatureAdded)="onNewFeatureAdded($event)" (newFeatureEmitter)="addNewFeature($event)"
                        (actionEmitter)="onActionEmit($event)" (snapEmitter)="onSnapToggle($event)"
                        (showActiveLayerEmitter)="onShowActiveLayer($event)">
                      </app-edit-features>
                    </div>
                  }
                  @if ((propertiesDBLink$ | async) && (propertiesDBLink$ | async).length > 0) {
                    <div id="propertyDbLinks" class="rightPanel propertyInfo"
                      [style.height.px]="(panelHeight - 1)">
                      <div class="multi plans">
                        <div class="rightPanelControls d-flex justify-content-end w-100">
                          <button (click)="closePropertyInformation()" class="float-left btn-close my-1 d-block" title="Close">
                            <h3 class="multi-address">Multiple Plans</h3>
                            <i class="far fa-chevron-right"></i>
                          </button>
                        </div>
                        <!-- multiple dblinks -->
                        @if ((propertiesDBLink$ | async)) {
                          <div class="addresses">
                            @for (dblink of (propertiesDBLink$ | async); track dblink) {
                              <div class="address">
                                <button class="w-100 btn btn-link d-flex justify-content-between"
                                  (click)="GetPropertyByDbLink(dblink.dbLink)">
                                  <span>
                                    {{dblink.dbLink}} {{dblink.airSpace == 'Y' ? ' - (Air Space)' : ''}}
                                  </span>
                                  <i class="far fa-chevron-right"></i>
                                </button>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if ((propertiesInfo$ |
                    async) && (propertiesInfo$ | async)[0]) {
                    <div id="propretyInfo" class="rightPanel propertyInfo" [style.height.px]="(panelHeight - 1)">
                      @if ((propertiesInfo$ | async)[0].properties.length ===1 && (propertiesInfo$ | async)[0].properties[0].addresses.length <= 1) {
                        <div
                          >
                          <dnv-property-info [propertyInfo]="(propertiesInfo$ | async)" [selectedProperty]="(selectedProperty$ | async)"
                            [headerHeight]="headerHeight" [panelHeight]="panelHeight" [appSettings]="(application$ | async).appSettings"
                            (closePanel)="closePropertyInformation()" (openDrawingEmitter)="openDrawing($event)"
                            (backToMultiEmitter)="GetMultipleResults($event)" [opacity]="(mapState$ | async).orthoOpacity"
                            [energovInfo]="(energovInfo$ | async)" [scrollToTop]="propertyInfoScrollToTop">
                          </dnv-property-info>
                        </div>
                      }
                      <!-- 1 property, multiple addresses, example strata -->
                      @if ((propertiesInfo$ | async)[0].properties[0].addresses.length > 1) {
                        <div class="multi">
                          <div class="rightPanelControls d-flex justify-content-end w-100">
                            <button (click)="BackToPlansOrClose()" class="float-left btn-close my-1 d-block" title="Close">
                              <h3 class="multi-address">Multiple Addresses</h3>
                              <i class="far fa-chevron-right"></i>
                            </button>
                          </div>
                          <div class="addresses">
                            @for (address of (propertiesInfo$ | async)[0].properties[0].addresses; track address) {
                              <div class="address">
                                <button class="w-100 btn btn-link d-flex justify-content-between"
                                  (click)="setAddress(address.fullAddress, null)">
                                  {{address.fullAddress}}
                                  <i class="far fa-chevron-right"></i>
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                      }
                      <!-- multiple properties, 1 address-->
                      @if ((propertiesInfo$ | async)[0].properties.length > 1 && (propertiesInfo$ | async)[0].properties[0].addresses.length === 1) {
                        <div
                          class="multi">
                          <div class="rightPanelControls d-flex justify-content-end w-100">
                            <button (click)="BackToPlansOrClose()" class="float-left btn-close my-1 d-block" title="Close">
                              <h3 class="multi-address">Multiple Addresses</h3>
                              <i class="far fa-chevron-right"></i>
                            </button>
                          </div>
                          <div class="addresses">
                            @for (property of (propertiesInfo$ | async)[0].properties; track property) {
                              <div class="address">
                                <button class="w-100 btn btn-link d-flex justify-content-between"
                                  (click)="setAddress(property.addresses[0].fullAddress, property.dbLink)">
                                  {{property.addresses[0].fullAddress}}
                                  <i class="far fa-chevron-right"></i>
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (application.toolboxStatus === ToolboxStatus.CCTV && applicationState.cctvInspections && applicationState.cctvInspections.length > 0) {
                    <div id="cctv" class="rightPanel cctv"
                      [style.height.px]="panelHeight">
                      <div class="multi">
                        <div class="rightPanelControls d-flex justify-content-end w-100">
                          <button (click)="closeCCTV()" class="float-left btn-close my-1 d-block" title="Close">
                            <h3 class="multi-address">Sanitary CCTV</h3>
                            <i class="far fa-chevron-right"></i>
                          </button>
                        </div>
                        <dnv-cctv-inspections [cctvInspections]="applicationState.cctvInspections"
                          [selectedCctvInspection]="applicationState.selectedCctvInspection" (selectCctv)="onSelectCctv($event)"
                          [inspHeight]="inspectionHeight" [cctvNotes]="applicationState.cctvNotes"
                          [excludeFeaturesList]="(mapState$ |async).excludeFeatureInfo"
                          [featureLayers]="(mapState$ |async).featureLayers" [layers]="(layerState$ | async).layers"
                          [surroundFeatureList]="(mapState$ |async).surroundingFeatureList"
                          (highlightFeature)="highlightCCTV($event.url, $event.objectId)">
                        </dnv-cctv-inspections>
                      </div>
                    </div>
                  }
                  @if ((propertiesState$ | async) && (propertiesState$ | async).svcconn) {
                    <div id="svcConnPanel" class="rightPanel svc-conn"
                      [style.height.px]="panelHeight">
                      <div class="multi">
                        <dnv-svc-conn-tool [selectedServiceConnection]="(propertiesState$ | async).svcconn"
                          (closePanel)="closeServiceConnections()" (openReport)="openReport($event)"
                          (openDrawingEmitter)="openDrawing($event)"
                          (highlightFeature)="highlightServiceConnection($event.name, $event.objectId)">
                        </dnv-svc-conn-tool>
                      </div>
                    </div>
                  }
                  <div [class.fade]="application.status !== ApplicationStatus.Table" class="grid-panel">
                    <app-grid-view [applicationStatus]="(application$ | async).status" [layerState]="layerState$ | async"
                      [selectedLayer]="gridSelectLayer$ | async" [gridData]="gridSelectLayerCache$ | async"
                      (gridViewUpdate)="gridViewUpdate($event)" (closeGridEmitter)="toggleTable(application.status)">
                    </app-grid-view>
                  </div>
                  <div [class.fade]="wmrpConditions === false" [class.wmrp]="wmrpConditions === true" class="grid-panel top wmrp-conditions">
                    <div class="row d-flex justify-content-between m-0">
                      <div class="count">{{chkCount}} modules enabled</div>
                      <button type="button" class="btn btn-link no-border btn-close" (click)="toggleWMRPConditions()">
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                    <app-wmrp-conditions [wmrpMod]="(wmrpModule$ | async)" [materials]="(materials$ | async)"
                      [panelHeight]="panelHeight+20" [currentConditions]="(currentConditions$ | async)" [editable]="true"
                      [checkCount]="chkCount" [isWMRPUser]="isWMRP('WMRP USER')" (countEmitter)="updateCount($event)"
                      (runAnalysisCustomEmitter)="onRunAnalysisCustom($event)"
                      (runAnalysisTemplateEmitter)="onRunAnalysisTemplate($event)"
                    (paramsSaveEmitter)="onSaveParams($event)"></app-wmrp-conditions>
                  </div>
                  <div [class.fade]="!showAnalysisParameters" class="grid-panel wmrp-conditions">
                    <div class="row justify-content-between mx-0">
                      <ul ngbNav #nav="ngbNav" class="nav-tabs">
                        <li ngbNavItem>
                          <a ngbNavLink>Parameters</a>
                          <ng-template ngbNavContent class="px-0">
                            <app-wmrp-conditions [wmrpMod]="(wmrpModule$ | async)" [materials]="(materials$ | async)"
                              [panelHeight]="450" [currentConditions]="(currentConditions$ | async)" [editable]="false"
                            (paramsSaveEmitter)="onSaveParams($event)" (exportEmitter)="onExportParams()"></app-wmrp-conditions>
                          </ng-template>
                        </li>
                        <li ngbNavItem>
                          <a ngbNavLink>Hazard Score</a>
                          <ng-template ngbNavContent>
                            <div class="hazard-score">
                              <h5>Hazard Score</h5>
                              <p>Modify the slider to update the symbology of the hazard score.</p>
                              <div [formGroup]="hazardForm" class="d-flex justify-content-between hazard-slider pt-4">
                                <div class="form-group text-center">
                                  <label>Low / Medium</label>
                                  <input type="text" formControlName="hazardMin" class="form-control-sm"
                                    (change)="onChangeHazard('min')">
                                  </div>
                                  <ngx-slider [options]="hazardSliderOptions" [(value)]="minValue" [(highValue)]="maxValue"
                                    (userChange)="getHazardSliderValue()">
                                  </ngx-slider>
                                  <div class="form-group text-center">
                                    <label>Medium / High</label>
                                    <input type="text" formControlName="hazardMax" class="form-control-sm"
                                      (change)="onChangeHazard('max')">
                                    </div>
                                  </div>
                                </div>
                              </ng-template>
                            </li>
                          </ul>
                        </div>
                        <div [ngbNavOutlet]="nav" class="mt-2"></div>
                        <!-- {{(savedTemplate$ | async) | json}} -->
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0">
                    <button type="button" class="btn btn-primary btn-expand" [class.d-block]="showAnalysisParametersBtn"
                      [class.on]="showAnalysisParameters" (click)="toggleParamPanel()">
                      @if (showAnalysisParameters) {
                        <span>Minimize Parameters <i class="fa-regular fa-minimize"></i></span>
                      }
                      @if (!showAnalysisParameters) {
                        <span>
                          Expand Parameters
                          <i class="fa-regular fa-expand"></i>
                        </span>
                      }
                    </button>
                  </div>
                </div>
              }


              <ng-template #rt let-r="result" let-t="term">
                <div class="d-flex flex-row pr-2">
                  <i class="{{getClass(r.type)}}"></i>
                  <div class="result-item">{{ r.name }} {{ checkTrailType(r.type)}}</div>
                </div>
              </ng-template>

              <ng-template #engSearch let-r="result" let-t="term">
                {{ r.name }}
              </ng-template>

              <ng-template #assetSearchTemplate let-r="result" let-t="term">
                {{ r.assetId }}
              </ng-template>

              <!-- layer info popup-->
              <ng-template #content let-modal>
                <div class="modal-header">
                  <h5>Layer Info</h5>
                </div>

                <div class="modal-body" [innerHtml]="layerInfo$ | async">
                </div>

                <div class="modal-footer">

                  <button type="button" class="btn" (click)="dismiss()"><i class="fas fa-times"></i>OK</button>

                </div>

              </ng-template>

              <ng-template #replacementSchedule let-modal>
                <div class="mx-3">
                  <div class="modal-header mb-3">
                    <h4 class="mb-0">Replacement Schedule Parameters</h4>
                    <button type="button" class="btn btn-close" aria-label="Close" (click)="modal.close()">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                  <form [formGroup]="replacementSchedForm" #schedForm="ngForm" class="d-flex flex-row justify-content-center">
                    <table class="schedule-form">
                      <tr>
                        <td><label for="analysisValueEnabled">Analysis Value Enabled </label></td>
                        <td><input type="checkbox" formControlName="analysisValueEnabled" id="analysisValueEnabled"></td>
                      </tr>
                      <tr class="d-none">
                        <td><label for="addressingEnabled">Addressing Enabled </label></td>
                        <td><input type="checkbox" formControlName="addressingEnabled" id="addressingEnabled"></td>
                      </tr>
                      <tr>
                        <td><label for="endOfLifeEnabled">End of Life Enabled </label></td>
                        <td><input type="checkbox" formControlName="endOfLifeEnabled" id="endOfLifeEnabled"></td>
                      </tr>
                      <tr>
                        <td><label for="numberOfBreaksEnabled">Number of Breaks Enabled </label></td>
                        <td><input type="checkbox" formControlName="numberOfBreaksEnabled" id="numberOfBreaksEnabled"></td>
                      </tr>
                      <tr>
                        <td>
                          <label for="exclusionLayerEnabled">Exclude Mains From Exclusion Layer </label>
                        </td>
                        <td><input type="checkbox" formControlName="exclusionLayerEnabled" id="exclusionLayerEnabled"></td>
                      </tr>
                      <tr>
                        <td><label for="replacementMetres">Replacement Metres Per Year </label></td>
                        <td>
                          <input formControlName="replacementMetres" type="text" maxlength="6" pattern="[0-9]*">
                          @if (replacementSchedForm.controls['replacementMetres'].invalid && replacementSchedForm.controls['replacementMetres'].touched) {
                            <div
                            class="text-danger small">Please enter a number</div>
                          }
                        </td>
                      </tr>
                      <tr>
                        <td><label for="startYear">Start Year </label></td>
                        <td>
                          <input type="text" formControlName="startYear" maxlength="4">
                          @if (replacementSchedForm.controls['startYear'].invalid && replacementSchedForm.controls['startYear'].touched) {
                            <div
                              class="text-danger small">
                              Please
                              enter a number
                            </div>
                          }
                        </td>
                      </tr>
                      <tr>
                        <td><label for="endYear">End Year </label></td>
                        <td>
                          <input type="text" formControlName="endYear" maxlength="4">
                          @if (replacementSchedForm.controls['endYear'].invalid && replacementSchedForm.controls['endYear'].touched) {
                            <div
                              class="text-danger small">
                              Please enter
                              a number
                            </div>
                          }
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div class="modal-footer mt-3 d-flex">
                            <button class="btn btn-primary d-flex justify-content-center" type="submit"
                              (click)="generateReplacementSchedule()" [disabled]="schedForm.invalid">
                              Generate replacement
                              schedule
                            </button>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </form>
                </div>
              </ng-template>

              <ng-template #modalWmrp let-modal>
                <div class="modal-header">
                  <h4>WMRP</h4>
                  <button type="button" class="btn btn-close" aria-label="Close" (click)="modal.close()">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div class="modal-body d-flex justify-content-start">
                  <i class="fa-solid fa-octagon-exclamation fa-3x mr-3"></i>
                  <p>
                    You do not have permission to access this data, please contact
                    Utilities for approval.
                  </p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-dark" (click)="dismiss()" ngbAutofocus>Close</button>
                </div>
              </ng-template>

              <ng-template #wmrpTitleModal let-modal>
                <div class="modal-header">
                  <h4>Enter a title for {{this.selectedAnalysisType}} ID {{this.selectedAnalysisType === 'analysis' ?
                  this.selectedAnalysisJobId : this.selectedScheduleJobId}}</h4>
                  <button type="button" class="btn btn-close" aria-label="Close" (click)="modal.close()">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div class="modal-body">
                  <form [formGroup]="analysisTitleForm">
                    <div class="row g-3 align-items-center">
                      <div class="col-sm-2">
                        <label for="analysisTitle" class="col-form-label">Title:</label>
                      </div>
                      <div class="col-sm-10">
                        <input type="analysisTitle" class="form-control" formControlName="analysisTitle">

                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-9 offset-sm-3">
                        @if (this.analysisTitleForm.get('analysisTitle').value.length > 50) {
                          <div class="text-danger small mt-1">
                            Title is too long
                          </div>
                        }
                      </div>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-primary" (click)="saveTitle(this.selectedAnalysisType)"
                  [disabled]="this.analysisTitleForm.get('analysisTitle').value.length === 0">Save</button>
                  <button type="button" class="btn btn-outline-dark" (click)="dismiss()">Cancel</button>
                </div>
              </ng-template>

              <ng-template #confirmDelAnalysis let-modal>
                <div class="modal-header">
                  <h4>Delete</h4>
                  <button type="button" class="btn btn-close" aria-label="Close" (click)="modal.close()">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div class="modal-body">
                  Analysis Id {{selectedAnalysisJobId}} has {{scheduleCount}} Replacement Schedule(s).<br /><br />
                  Are you sure you want to delete Analysis Id {{selectedAnalysisJobId}}?
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-primary" (click)="deleteAnalysisRun()">Yes</button>
                  <button type="button" class="btn btn-outline-dark" (click)="dismiss()">Cancel</button>
                </div>
              </ng-template>

              <ng-template #confirmDelSchedule let-modal>
                <div class="modal-header">
                  <h4>Delete</h4>
                  <button type="button" class="btn btn-close" aria-label="Close" (click)="modal.close()">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div class="modal-body">
                  Are you sure you want to delete Schedule Id {{selectedScheduleJobId}}?
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-primary" (click)="deleteScheduleRun()">Yes</button>
                  <button type="button" class="btn btn-outline-dark" (click)="dismiss()">Cancel</button>
                </div>
              </ng-template>


              <svg class="leaflet-zoom-animated" width="10" height="10" viewBox="-761 -367 10 10"
                style="transform: translate3d(-761px, -367px, 0px);">
                <defs>
                  <pattern id="hstripes" x="0" y="0" width="8" height="8" patternUnits="userSpaceOnUse"
                    patternContentUnits="userSpaceOnUse">
                    <path stroke="#000" stroke-opacity="1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"
                    pointer-events="none" d="M0 0.5 H 8"></path>
                    <path stroke="#ffffff" stroke-opacity="0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"
                    fill="none" pointer-events="none" d="M0 3 H 8"></path>

                  </pattern>
                  <pattern id="vstripes" x="0" y="0" width="8" height="8" patternUnits="userSpaceOnUse"
                    patternContentUnits="userSpaceOnUse" patternTransform="rotate(90) ">
                    <path stroke="#000" stroke-opacity="1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"
                    pointer-events="none" d="M0 0.5 H 8"></path>
                    <path stroke="#ffffff" stroke-opacity="0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"
                    fill="none" pointer-events="none" d="M0 3 H 8"></path>
                  </pattern>
                  <pattern id="grid" x="0" y="0" width="11" height="11" patternUnits="userSpaceOnUse"
                    patternContentUnits="userSpaceOnUse">
                    <rect stroke="#000" stroke-opacity="1" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" fill="none"
                    pointer-events="none" x="0" y="0" width="10" height="10"></rect>
                  </pattern>
                  <pattern id="crosshatch" x="0" y="0" width="11" height="11" patternUnits="userSpaceOnUse"
                    patternContentUnits="userSpaceOnUse" patternTransform="rotate(45) ">
                    <rect stroke="#000" stroke-opacity="1" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" fill="none"
                    pointer-events="none" x="0" y="0" width="10" height="10"></rect>
                  </pattern>

                  <pattern id="forward-diagonal" patternUnits="userSpaceOnUse" width="10" height="10">
                    <image
        xlink:href="data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+CiAgPHJlY3Qgd2lkdGg9JzEwJyBoZWlnaHQ9JzEwJyBmaWxsPSd3aGl0ZScvPgogIDxwYXRoIGQ9J00tMSwxIGwyLC0yCiAgICAgICAgICAgTTAsMTAgbDEwLC0xMAogICAgICAgICAgIE05LDExIGwyLC0yJyBzdHJva2U9J2JsYWNrJyBzdHJva2Utd2lkdGg9JzEnLz4KPC9zdmc+Cg=="
        x="0" y="0" width="10" height="10"> </image>
                  </pattern>

                  <pattern id="backward-diagonal" patternUnits="userSpaceOnUse" width="10" height="10"
                    patternTransform="rotate(90 0 0)">
                    <image
        xlink:href="data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+CiAgPHJlY3Qgd2lkdGg9JzEwJyBoZWlnaHQ9JzEwJyBmaWxsPSd3aGl0ZScvPgogIDxwYXRoIGQ9J00tMSwxIGwyLC0yCiAgICAgICAgICAgTTAsMTAgbDEwLC0xMAogICAgICAgICAgIE05LDExIGwyLC0yJyBzdHJva2U9J2JsYWNrJyBzdHJva2Utd2lkdGg9JzEnLz4KPC9zdmc+Cg=="
        x="0" y="0" width="10" height="10"> </image>
                  </pattern>

                  <pattern id="cross" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse">
                    <rect x="0" y="0" width="10" height="10" style="stroke: #000; fill: #fff" />
                  </pattern>

                  <pattern id="diagonal-cross" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse"
                    patternTransform="rotate(45 0 0)">
                    <rect x="0" y="0" width="10" height="10" style="stroke: #000; fill: #fff" />
                  </pattern>
                </defs>
              </svg>